import React from "react";
import "./MeaBlore.css";
const MeaBlore = () => {
  return (
    <div className="meaBloreContainer">
      <h1>MEA <span>Apostille</span> in Bangalore</h1>
      <p>
        MEA has the authority to issue Apostille & authenticate the documents
        issued in India for usage in a foreign country. MEA is the branch of the
        government that deals with foreign matters. There are various other
        steps that need to be followed before finally acquiring an MEA
        attestation stamp on your document.
      </p>
      <p>
        The steps for educational, personal, & commercial documents differ
        accordingly for the process of MEA authentication. Goodwayattestation is
        one of the best MEA Apostille in Bangalore for Certificate & present MEA
        authentication for your documents.
      </p>
    </div>
  );
};

export default MeaBlore;
